import type {RequestFilter} from './types';

export const embeddedAuthLinkCreateFilter: RequestFilter = {
  matchers: [
    {
      urlPath: /\/v1\/embedded_authentication_links/,
      method: 'POST',
    },
  ],

  filterRequest: ({request}) => {
    return {request, keyType: 'account_session'};
  },
};
